var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bbButton',{staticClass:"button--accent button--wide-4",attrs:{"label":_vm.label},on:{"click":function($event){return _vm.scrollToClass('.scrollto')}}})}
var staticRenderFns = []

export { render, staticRenderFns }